import { useUserAvatarEffectId } from '@store'

import { useAvatarEffectById } from './useAvatarEffectById'

export const useUserAvatarEffect = () => {
  const userAvatarEffectId = useUserAvatarEffectId()
  const { effect: userAvatarEffect } = useAvatarEffectById({
    effectId: userAvatarEffectId || '',
  })

  return { userAvatarEffect }
}
